import config from "../config";


function Recharge() {

    function addSilver(num){
        const silver = localStorage.getItem("Silver")
        localStorage.setItem("Silver", parseInt(silver) ? parseInt(silver) + num: num)
    }
    function addGold(num){
        const gold = localStorage.getItem("Gold")
        localStorage.setItem("Gold", parseInt(gold) ? parseInt(gold) + num: num)
    }
    return(
        <div className="card">
             <div className="card-header">Recharge</div>
                <div className="card-body">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="row">Silver</th>
                                <td><button onClick = {() => addSilver(12)}>$5.00 for 10 Silver CobBucks + 2 Extra</button></td>
                                <td><button onClick = {() => addSilver(36)}>$15.00 for 30 Silver CobBucks + 6 Extra</button></td>
                                <td><button onClick = {() => addSilver(60)}>$25.00 for 50 Silver CobBucks + 10 Extra</button></td>
                            </tr>
                            <tr>
                                <th scope="row">Gold</th>
                                <td><button onClick = {() => addGold(6)}>$50.00 for 5 Gold CobBucks + 1 Extra</button></td>
                                <td><button onClick = {() => addGold(10)}>$80.00 for 8 Gold CobBucks + 2 Extra</button></td>
                                <td><button onClick = {() => addGold(20)}>$150 for 15 Gold CobBucks + 5 Extra</button></td>
                            </tr>
                        </thead>
                    </table>
                    You can also trade in Brass CobBucks for Silver CobBucks at a ratio of 100:1
                </div>
        </div>
    )
}


export default Recharge;